import { WelcomePage } from './../welcome/welcome';
import { BqApiProvider } from './../../providers/bq-api/bq-api';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from "ionic-angular";
import { ToastController } from "ionic-angular";
import { TranslateService } from '@ngx-translate/core';

import { ContactSocketPage } from './../contact-socket/contact-socket';
import { PresentationProductPage } from './../presentation-product/presentation-product';


@IonicPage()
@Component({
  selector: 'page-needs-diagnosis',
  templateUrl: 'needs-diagnosis.html'
})
export class NeedsDiagnosisPage {
  public diagnosticComment: string;
  public p20Selection: number;
  public p21Selection: number;
  public p22Selection: number;
  public p23Selection: number;
  public p24Selection: number;
  public p25Selection: number;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {
    this.p20Selection = 0;
    this.p21Selection = 0;
    this.p22Selection = 0;
    this.p23Selection = 0;
    this.p24Selection = 0;
    this.p25Selection = 0;
    this.diagnosticComment = '';
  }

  ionViewDidLoad() {
    this.p20Selection = this.bqApi.getStep(20) || 0;
    this.p21Selection = this.bqApi.getStep(21) || 0;
    this.p22Selection = this.bqApi.getStep(22) || 0;
    this.p23Selection = this.bqApi.getStep(23) || 0;
    this.p24Selection = this.bqApi.getStep(24) || 0;
    this.p25Selection = this.bqApi.getStep(25) || 0;
    this.diagnosticComment = this.bqApi.getComment(3) || '';
  }

  updateSteps(){
    if (this.p20Selection !== 0) {
      this.bqApi.setStep(20, this.p20Selection);
    }
    if (this.p21Selection !== 0) {
      this.bqApi.setStep(21, this.p21Selection);
    }
    if (this.p22Selection !== 0) {
      this.bqApi.setStep(22, this.p22Selection);
    }
    if (this.p23Selection !== 0) {
      this.bqApi.setStep(23, this.p23Selection);
    }
    if (this.p24Selection !== 0) {
      this.bqApi.setStep(24, this.p24Selection);
    }
    if (this.p25Selection !== 0) {
      this.bqApi.setStep(25, this.p25Selection);
    }

    if( this.diagnosticComment !== '' ){
      this.bqApi.setComment(3, this.diagnosticComment );
    }

    this.bqApi.syncSteps();
  }

  nextStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(PresentationProductPage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();

    if (this.bqApi.getStep(11) === 4) {
      this.navCtrl.push(WelcomePage);
    } else {
      this.navCtrl.push(ContactSocketPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/needs-diagnosis/needs-diagnosis.ts